import { BaseMethodReturnType } from 'src/types/commonTypes';
import connectionInfoSubsystemStrategy from './connectionInfoSubsystemStrategy';

class ConnectionInfoSubsystem {
  async hasInternetAccess(): Promise<BaseMethodReturnType<boolean>> {
    return connectionInfoSubsystemStrategy.hasInternetAccess();
  }

  async listenHasInternetAccess(
    callback: (hasInternetAccess: boolean) => void
  ): Promise<BaseMethodReturnType<{ remove: () => void }>> {
    return connectionInfoSubsystemStrategy.listenHasInternetAccess(callback);
  }

  useHasInternetAccess(
    React: any
  ): BaseMethodReturnType<boolean | undefined, { loading: boolean }> {
    const [hasInternetAccess, setHasInternetAccess] = React.useState();
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
      let unmounted = false;
      this.hasInternetAccess().then((result) => {
        if (unmounted) {
          console.error(
            'ConnectionInfoSubsystem.useHasInternetAccess - Component unmounted before hasInternetAccess result'
          );
          return;
        }
        if (result.result !== undefined) {
          setHasInternetAccess(result.result);
        }

        setLoading(false);
      });
      let unmountListen = 0;

      const listenerPromise = this.listenHasInternetAccess(
        (hasInternetAccess) => {
          if (unmounted) {
            unmountListen++;

            console.error(
              `ConnectionInfoSubsystem.useHasInternetAccess - listener called after unmount ${unmountListen} times`
            );
            return;
          }
          setHasInternetAccess(hasInternetAccess);
        }
      );

      return () => {
        listenerPromise.then((result) => {
          result.result?.remove();
        });
        unmounted = true;
      };
    }, []);

    return {
      result: hasInternetAccess,
      loading
    };
  }
}

const connectionInfoSubsystem = new ConnectionInfoSubsystem();

export default connectionInfoSubsystem;
